
import ERROR_CODES from "./errorCodes";

const errorList = []; // Stores all logged errors

const logError = (errorKey) => {
    const errorInfo = ERROR_CODES[errorKey];

    if (!errorInfo) {
        console.error("Unknown error key:", errorKey);
        return;
    }

    const errorEntry = {
        code: errorInfo.code,
        name: errorInfo.name,
        description: errorInfo.message,
        filename: errorInfo.file,
    };

    console.error(`Error Logged:`, errorEntry);
    errorList.push(errorEntry);

    return errorInfo.code;
};


export { logError };